<app-navbar></app-navbar>
<router-outlet />
<app-scroll-to-top></app-scroll-to-top>